<template>
  <div v-if="game" class="pravo">
    <div class="game-controls">
      <Time />
      <Rounds />
    </div>

    <PravoTop Image="gameSettings" :Header="this.gameName" />
    <div class="pravo__obsah">
      <div class="pravo__buttons">
        <GoBack
          href="/gameManager/allGames"
          icon="gameOverview"
          text="Back to all games"
        />

        <!--        <GoBack-->
        <!--          href="/gameManager/gameOverviewManager"-->
        <!--          icon="gameOverviewManager"-->
        <!--          additionalClass="additionalButton"-->
        <!--          text="Game overview"-->
        <!--        />-->
      </div>

      <div class="grid">
        <div class="tabulka half">
          <div class="tabulka__top">
            <div class="tabulka__top__nadpis">Control the game</div>
          </div>

          <div class="tabulka__body">
            <div class="tabulka__body__full">
              <button
                class="button-manager"
                @click="toggleReady"
                style="margin-right: 30px"
              >
                Ready: <b>{{ ready }}</b>
              </button>
              <button
                class="button-manager"
                @click="endCurrentTurn"
                style="margin-right: 30px"
              >
                End current turn
              </button>
              <button class="button-manager" @click="endGame">
                End the game
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

        <div class="tabulka half">
          <div class="tabulka__body">
            <div class="tabulka__body__headline">
              <div class="tabulka__body__headline__gray">Round lenght:</div>
              <div class="tabulka__body__headline__blue">
                {{ game.turnLength }}s
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="tabulka half">
          <div class="tabulka__top">
            <div class="tabulka__top__nadpis">Change this round</div>
          </div>

          <div class="tabulka__body">
            <!--            <div class="tabulka__body__headline">-->
            <!--              <div class="tabulka__body__headline__gray">Round lenght:</div>-->
            <!--              <div class="tabulka__body__headline__blue">{{ game.turnLength }}s</div>-->

            <!--              &lt;!&ndash;              <div class="tabulka__body__headline__time">&ndash;&gt;-->
            <!--              &lt;!&ndash;                <div class="tabulka__body__headline__time__text">&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__text&#45;&#45;first">new time</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__text&#45;&#45;second">to next round</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                <div class="tabulka__body__headline__time__countdown">&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__countdown__value">{{timeToNextRound | formatTime}}</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__countdown__seconds">s</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
            <!--              &lt;!&ndash;              </div>&ndash;&gt;-->

            <!--              <div class="clearfix"></div>-->
            <!--            </div>-->

            <div class="tabulka__body__full">
              <div class="tabulka__body__inlineHeadline">
                Extend this round:
              </div>

              <div class="tabulka__body__inputPlusMinus">
                <button
                  class="tabulka__body__inputPlusMinus__button minus"
                  @click="thisRoundExtend('minus')"
                >
                  -
                </button>
                <input
                  type="text"
                  class="tabulka__body__inputPlusMinus__input"
                  v-model.number="postponeRoundInput"
                />
                <button
                  class="tabulka__body__inputPlusMinus__button plus"
                  @click="thisRoundExtend('plus')"
                >
                  +
                </button>
                <div class="tabulka__body__inputPlusMinus__end">seconds</div>
              </div>

              <div
                class="tabulka__body__inlineButton right"
                @click="postponeRound"
              >
                Apply changes
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
        </div>

        <div class="tabulka half">
          <div class="tabulka__top">
            <div class="tabulka__top__nadpis">Add player</div>
          </div>

          <div class="tabulka__body">
            <div class="tabulka__body__full">
              <div class="tabulka__body__inputAddPlayer">
                <select class="addTeamMemberSelect" v-model="addPlayerTeam">
                  <option disabled selected hidden :value="null">
                    Choose team
                  </option>
                  <option
                    v-for="team in allTeams"
                    :key="team.id"
                    :value="team.id"
                  >
                    {{ team.name }}
                  </option>
                </select>
              </div>
              <div class="tabulka__body__inputAddPlayer">
                <input
                  type="text"
                  class="tabulka__body__searchboxplayer"
                  placeholder="Type email or username"
                  v-model="searchPlayer"
                  @input="onChangeAutocomplete"
                />
                <ul v-show="isOpenAutocomplete" class="autocomplete-results">
                  <li
                    v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    class="autocomplete-result"
                  >
                    {{ result.username }}
                  </li>
                </ul>
              </div>

              <div class="tabulka__body__inlineButton right" @click="addPlayer" :disabled="disabledAddPlayer()">
                Add player
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
        </div>

        <div class="tabulka half">
          <div class="tabulka__top">
            <div class="tabulka__top__nadpis">Change game settings</div>
          </div>

          <div class="tabulka__body">
            <!--            <div class="tabulka__body__headline">-->
            <!--              <div class="tabulka__body__headline__gray">Round lenght:</div>-->
            <!--              <div class="tabulka__body__headline__blue">{{ game.turnLength }}s</div>-->

            <!--              &lt;!&ndash;              <div class="tabulka__body__headline__time">&ndash;&gt;-->
            <!--              &lt;!&ndash;                <div class="tabulka__body__headline__time__text">&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__text&#45;&#45;first">time to</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__text&#45;&#45;third">game end</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                <div class="tabulka__body__headline__time__countdown special">&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__countdown__value">{{timeToGameEnd | formatTime}}</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__countdown__seconds">s</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                  <div class="tabulka__body__headline__time__countdown__evaluation">+20 minutes for evaluation</div>&ndash;&gt;-->
            <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
            <!--              &lt;!&ndash;              </div>&ndash;&gt;-->

            <!--              <div class="clearfix"></div>-->
            <!--            </div>-->

            <!--            <div class="tabulka__body__half smaller">-->
            <!--              <div class="tabulka__body__inlineHeadline">-->
            <!--                Rounds:-->
            <!--              </div>-->

            <!--              <div class="tabulka__body__inlineText bold">{{game.maxTurn}}</div>-->
            <!--            </div>-->

            <div class="tabulka__body__half">
              <div class="tabulka__body__inlineHeadline">
                New number of rounds:
              </div>

              <div class="tabulka__body__inputPlusMinus bigger">
                <button
                  class="tabulka__body__inputPlusMinus__button minus"
                  @click="minusMaxTurns()"
                >
                  -
                </button>
                <input
                  type="text"
                  class="tabulka__body__inputPlusMinus__input"
                  v-model="gameSettings.maxTurn"
                />
                <button
                  class="tabulka__body__inputPlusMinus__button plus"
                  @click="gameSettings.maxTurn++"
                >
                  +
                </button>
              </div>
            </div>

            <div class="tabulka__body__full">
              <div class="tabulka__body__inlineHeadline">Round length:</div>

              <div class="tabulka__body__inputPlusMinus bigger">
                <button
                  class="tabulka__body__inputPlusMinus__button minus"
                  @click="minusTurnLength()"
                >
                  -
                </button>
                <input
                  type="text"
                  class="tabulka__body__inputPlusMinus__input"
                  v-model="gameSettings.turnLength"
                />
                <button
                  class="tabulka__body__inputPlusMinus__button plus"
                  @click="plusTurnLength()"
                >
                  +
                </button>
                <div class="tabulka__body__inputPlusMinus__end">
                  seconds
                  <small>(applies from the following one)</small>
                </div>
              </div>
            </div>

            <div class="tabulka__body__full">
              <div
                class="tabulka__body__inlineButton right"
                @click="updateGame"
              >
                Apply changes
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <AllPlayers
          TableWidth="half"
          :sourceData="users"
          :myId="me.id"
          name="Player list"
        />
      </div>
    </div>

    <Modal ref="modalRef" width="600px">
      <div class="modal__questionHeader">
        Do you really want to end the game?
      </div>
      <div class="clearfix">
        <button class="modal__cancel" @click="closeModal()">Cancel</button>
        <button class="modal__approve" @click="terminateGame()">Yes</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import GoBack from "@/components/game/pravo/GoBack.vue";
import Rounds from "@/components/game/controls/Rounds.vue";
import Time from "@/components/game/controls/Time.vue";
import AllPlayers from "@/components/gameManager/AllPlayers.vue";

import Modal from "@/components/general/Modal.vue";
import ModalJs from "@/components/general/ModalJs.js";

export default {
  name: "gameSettings",
  mixins: [ModalJs],
  components: {
    Modal,
    PravoTop,
    GoBack,
    Rounds,
    Time,
    AllPlayers,
  },
  data() {
    return {
      postponeRoundInput: 60,
      searchPlayer: "",
      addPlayerTeam: null,
      addPlayerId: 0,
      kontrolaJmena: "",
      isOpenAutocomplete: false,
      results: [],
      items: [
        "Apple",
        "Banana",
        "Orange",
        "Mango",
        "Pear",
        "Peach",
        "Grape",
        "Tangerine",
        "Pineapple",
      ],
      timeToNextRound: 600,
      gameName: "Game settings",
      gameSettings: {
        maxTurn: _.get(this.$store.getters, "ownerCurrentGame.maxTurn"),
        turnLength: _.get(this.$store.getters, "ownerCurrentGame.turnLength"),
      },
    };
  },
  computed: {
    ...mapGetters({
      game: "ownerCurrentGame",
      ready: "readyForNextRound",
      users: "allPlayers",
      me: "me",
      allTeams: "gameAllTeams",
    }),
    timeToGameEnd() {
      if (this.maxTurn == 0) {
        return this.timeToNextRound;
      } else if (this.maxTurn == 1) {
        return this.followingRoundLength * 60 + this.timeToNextRound;
      } else {
        return (
          this.turnLength * (this.maxTurn - 1) * 60 +
          this.followingRoundLength * 60 +
          this.timeToNextRound
        );
      }
    },
  },
  methods: {
    terminateGame() {
      this.$router.push({ name: "GameManager.allGames" });
    },
    thisRoundExtend(direction) {
      if (direction == "plus") {
        this.postponeRoundInput++;
        this.timeToNextRound += 60;
      } else if (
        direction == "minus" &&
        this.postponeRoundInput > 0 &&
        this.timeToNextRound > 60
      ) {
        this.postponeRoundInput--;
        this.timeToNextRound -= 60;
      } else if (direction == "minus" && this.postponeRoundInput <= 0) {
        this.$toast.error(
          this.$t("messages.game-settigns.too-short-time-extension")
        );
      }
    },
    minusTurnLength() {
      if (this.gameSettings.turnLength > 10) {
        this.gameSettings.turnLength--;
      } else {
        this.$toast.error(
          this.$t("messages.game-settigns.too-short-turn-time")
        );
      }
    },
    plusTurnLength() {
      this.gameSettings.turnLength++;
    },
    minusMaxTurns() {
      if (this.gameSettings.maxTurn >= this.game.turn) {
        this.gameSettings.maxTurn--;
      } else {
        this.$toast.error(this.$t("messages.game-settigns.not-enought-turns"));
      }
    },
    plusMaxTurns() {
      this.gameSettings.maxTurn++;
    },
    async postponeRound() {
      await this.$store.dispatch("postponeRound", this.postponeRoundInput);
    },
    async endCurrentTurn() {
      if (confirm("End turn?")) {
        await this.$store.dispatch("endCurrentTurn");
      }
    },
    async endGame() {
      if (confirm("End game?")) {
        await this.$store.dispatch("endGame");
      }
    },
    async deleteGame() {
      if (confirm("Delete game?")) {
        await this.$store.dispatch("deleteGame");
      }
    },
    async toggleReady() {
      await this.$store.dispatch("waitForNextRound", !this.ready);
    },
    async updateGame() {
      await this.$store.dispatch("updateGame", this.gameSettings);
    },
    async filterResults() {
      if (this.searchPlayer.length > 3) {
        this.results = await this.$store.dispatch(
          "getPlayersBySearch",
          this.searchPlayer
        );
      }
    },
    async onChangeAutocomplete() {
      this.isOpenAutocomplete = true;
      await this.filterResults();
    },
    async addPlayer() {
      if (this.addPlayerTeam != null) {
        if (this.addPlayerId > 0) {
          await this.$store.dispatch("addPlayerToGame", {
            user: this.addPlayerId,
            team: this.addPlayerTeam,
          });
          console.log("Přidávám hráče!")
          this.addPlayerId = 0;
          this.searchPlayer = "";
          this.addPlayerTeam = null;
        } else {
          if (this.searchPlayer == "") {
            this.$toast.error(
              this.$t("messages.game-owner.add-player.no-player")
            );
          } else {
            this.kontrolaJmena = await this.$store.dispatch(
              "getPlayersBySearch",
              this.searchPlayer
            );
            console.log("Kontroluju jmeno");
            if(this.kontrolaJmena.length == 1){
              this.setResult(this.kontrolaJmena[0])
              this.addPlayer(true);
            }else{
              if(!this.users.some(data => data.username == this.searchPlayer)){
                this.$toast.error(
                  this.$t("messages.game-owner.add-player.incorrect-name")
                );
              }else{
                this.$toast.error(
                  this.$t("messages.game-owner.add-player.already-in-game")
                );
              }
            }
          }
        }
      } else {
        this.$toast.error(this.$t("messages.game-owner.add-player.no-team"));
      }
    },
    setResult(result) {
      this.searchPlayer = result.username;
      this.addPlayerId = result.id;
      this.isOpenAutocomplete = false;
    },
    disabledAddPlayer(){
      if(this.addPlayerId == 0){
        return true
      }else{
        return false
      }
    }
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Backspace') {
        this.addPlayerId = 0
      }
    });
  },
  mounted() {
    if (this.game != null) {
      this.gameName = "Game settings - " + this.game.name;
    }
  },
};
</script>

<style>
</style>
